import React from 'react';
import useAuth from '../utils/AuthContext';
import {Button, Col, Modal, Row} from 'antd';
import Title from 'antd/lib/typography/Title';
import Password from '../assets/password.svg';
import {useBoolean} from 'react-hanger';
import UpdatePasswordForm from '../components/user/UpdatePassword';
import {UserRole} from '../scaffold';
import {useHistory} from 'react-router-dom';

export default function IndexPage() {
  const auth = useAuth();
  const isUpdatePassword = useBoolean(false);
  const history = useHistory();
  return (
    <div>
      {auth.currentUser && (
        <Row gutter={20}>
          {auth.currentUser.role === UserRole.学生 && (
            <Col>
              <Button style={{height: 200}} onClick={() => history.push('submission/list')}>
                <img style={{width: 100, height: 100}} src={Password} alt="" />
                <Title level={4}>申请答辩</Title>
              </Button>
            </Col>
          )}
          {auth.currentUser.role === UserRole.教师 && (
            <Col>
              <Button style={{height: 200}} onClick={() => history.push('submission/list')}>
                <img style={{width: 100, height: 100}} src={Password} alt="" />
                <Title level={4}>申请列表</Title>
              </Button>
            </Col>
          )}
          {auth.currentUser.role === UserRole.管理员 && (
            <React.Fragment>
              <Col>
                <Button style={{height: 200}} onClick={() => history.push('submission/list')}>
                  <img style={{width: 100, height: 100}} src={Password} alt="" />
                  <Title level={4}>申请列表</Title>
                </Button>
              </Col>
              <Col>
                <Button style={{height: 200}} onClick={() => history.push('manage/term')}>
                  <img style={{width: 100, height: 100}} src={Password} alt="" />
                  <Title level={4}>批次管理</Title>
                </Button>
              </Col>
              <Col>
                <Button style={{height: 200}} onClick={() => history.push('manage/user')}>
                  <img style={{width: 100, height: 100}} src={Password} alt="" />
                  <Title level={4}>用户管理</Title>
                </Button>
              </Col>
              <Col>
                <Button style={{height: 200}} onClick={() => history.push('manage/userStatus')}>
                  <img style={{width: 100, height: 100}} src={Password} alt="" />
                  <Title level={4}>学业完成情况</Title>
                </Button>
              </Col>
            </React.Fragment>
          )}
          <Col>
            <Button style={{height: 200}} onClick={isUpdatePassword.setTrue}>
              <img style={{width: 100, height: 100}} src={Password} alt="" />
              <Title level={4}>修改密码</Title>
            </Button>
          </Col>
          <Modal title={'修改密码'} visible={isUpdatePassword.value} onCancel={isUpdatePassword.setFalse} footer={false}>
            <UpdatePasswordForm userId={auth.currentUser.id || 0} onSuccess={isUpdatePassword.setFalse} />
          </Modal>
        </Row>
      )}
    </div>
  );
}
